/** Base path do console master (prefixo da rota React). */
export const PLATFORM_CONSOLE_BASE = "/platform/xprobase";

/** Segmentos de URL para cada área do console (nível superior). */
export const PLATFORM_CONSOLE_SEGMENT = {
  workspaces: "workspaces",
  /** Mesmo padrão do portal revenda: página dedicada ao assistente de criação. */
  workspaceCreate: "workspaces/new",
  opportunities: "opportunities",
  insights: "insights",
  presence: "presence",
  segments: "segments",
  governance: "governance",
  catalog: "catalog",
};

/** Rotas absolutas por área. */
export const PLATFORM_CONSOLE_PATH = {
  workspaces: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.workspaces}`,
  workspaceCreate: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.workspaceCreate}`,
  opportunities: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.opportunities}`,
  insights: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.insights}`,
  presence: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.presence}`,
  segments: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.segments}`,
  governance: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.governance}`,
  catalog: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.catalog}`,
};

/**
 * Slugs antigos em ?tab= (platformConsoleTabs) → caminho destino.
 * Presença unifica "online" e "workspaces-online" com query ?view=
 */
export function legacyTabSlugToPath(tabSlug) {
  const s = String(tabSlug || "")
    .trim()
    .toLowerCase();
  const map = {
    workspaces: PLATFORM_CONSOLE_PATH.workspaces,
    analytics: PLATFORM_CONSOLE_PATH.insights,
    opportunities: PLATFORM_CONSOLE_PATH.opportunities,
    online: `${PLATFORM_CONSOLE_PATH.presence}?view=operators`,
    "workspaces-online": `${PLATFORM_CONSOLE_PATH.presence}?view=workspaces`,
    segments: PLATFORM_CONSOLE_PATH.segments,
    governance: PLATFORM_CONSOLE_PATH.governance,
    catalog: PLATFORM_CONSOLE_PATH.catalog,
  };
  return map[s] || PLATFORM_CONSOLE_PATH.workspaces;
}

/** Seções do detalhe do workspace (URL :section), ordem = índice da tab interna legada. */
export const WORKSPACE_DETAIL_SECTION_SLUGS = [
  "overview",
  "health",
  "usage",
  "invoices",
  "offers",
  "segment",
  "plan",
  "audit",
  "superlogica",
  "passenger-sales",
  "gupshup-reconcile",
];

export function workspaceDetailSectionToIndex(section) {
  const s = String(section || "")
    .trim()
    .toLowerCase();
  const i = WORKSPACE_DETAIL_SECTION_SLUGS.indexOf(s);
  return i >= 0 ? i : 0;
}

export function workspaceDetailIndexToSection(index) {
  const i = Number(index);
  if (!Number.isFinite(i) || i < 0 || i >= WORKSPACE_DETAIL_SECTION_SLUGS.length) {
    return WORKSPACE_DETAIL_SECTION_SLUGS[0];
  }
  return WORKSPACE_DETAIL_SECTION_SLUGS[i];
}

/** Caminho absoluto para um workspace + seção (deep link). */
export function workspaceDetailPath(dominioId, sectionIndexOrSlug) {
  const id = String(dominioId || "").trim();
  if (!id) return PLATFORM_CONSOLE_PATH.workspaces;
  let slug;
  if (typeof sectionIndexOrSlug === "number") {
    slug = workspaceDetailIndexToSection(sectionIndexOrSlug);
  } else {
    const s = String(sectionIndexOrSlug || "").trim().toLowerCase();
    slug = WORKSPACE_DETAIL_SECTION_SLUGS.includes(s) ? s : WORKSPACE_DETAIL_SECTION_SLUGS[0];
  }
  return `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.workspaces}/${id}/${slug}`;
}
